export default "__VITE_ASSET__BtOBh9BI__";